import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'dealerships';

export default {
  state: {
    all: [],
    current: null,
    google_address: null
  },

  mutations: {
    setAllDealerships(state, dealerships) {
      state.all = dealerships;
    },

    setCurrentDealership(state, dealership) {
      state.current = dealership;
    },

    addDealership(state, dealership) {
      state.all.push(dealership);
    },

    updateDealership(state, dealership) {
      state.all = _.map(state.all, (q) => {
        if (q.id !== dealership.id) return q;
        return dealership;
      });
    },
    switchDealership(state, dealership) {
      return true;
    },
    clearDealershipProblems(state, resp) {
      alert(resp.data.deleted + " successfully deleted");
      return true;
    },
    updatedSuccessfully(state, resp) {
      alert("Successfully updated");
      return true;
    },
    validateAddress(state, resp) {
      console.log(resp.data.result);
      state.google_address = resp.data.result;
      return true;
    }


  },

  actions: {
    fetchDealerships({commit}) {
      return api
        .instance()
        .get(`${apiVersion}/${source}`, {params: {team_id: auth.teamId()}})
        .then((resp) => {
          commit(
            "setAllDealerships",
            _.map(resp.data.data, (cat) => cat.attributes)
          );
        })
        .catch((err) => console.error("Failed to fetch dealerships", err));
    },

    changeCurrentDealership({commit, state}, dealershipId) {
      const dealership = _.findWhere(state.all, {id: parseInt(dealershipId)});
      commit("setCurrentDealership", dealership);

      return dealership;
    },

    createDealership({commit}, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .post(`${apiVersion}/${source}`, params)
        .then((resp) => {
          commit("addDealership", resp.data.data.attributes);
          return resp;
        });
    },

    updateDealership({commit}, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .put(`${apiVersion}/${source}/${params.id}`, params)
        .then((resp) => {
          commit("updateDealership", resp.data.data.attributes);
        });
    },

    switchDealershipAPI({commit}, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .put(`${apiVersion}/${source}/${params.id}/switch`, params)
        .then((resp) => {
          commit("switchDealership", resp.data.data.attributes);
        });
    },

    clearDealershipProblemsAPI({commit}, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .put(`${apiVersion}/${source}/${params.id}/clear_problems`, params)
        .then((resp) => {
          commit("clearDealershipProblems", resp);
          return resp.data;
        });
    },
    updateAddressFromWidgetAPI({commit}, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .put(`${apiVersion}/${source}/${params.id}/update_from_widget`, params)
        .then((resp) => {
          commit("updatedSuccessfully", resp);
          return resp.data;
        });
    },
    validateAddressOnGoogle({commit}, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .post(`${apiVersion}/addresses`, {address_data: params.address})
        .then((resp) => {
          commit("validateAddress", resp);
          return resp.data;
        });
    }
  }
};

